import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-submit",
  "use": "icon-submit-usage",
  "viewBox": "50 50 900 900",
  "content": "<symbol class=\"icon\" viewBox=\"50 50 900 900\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-submit\"><path d=\"M512 128l184 192H544v448h-64V320H328l184-192z m384 384h-64v320H192V512h-64v384h768V512z\" p-id=\"9268\" fill=\"#1E427A\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol